import * as resolvePath from 'object-resolve-path';

export const assignment = (row: any, key: string) => {
  const assignment = checkForProp(row, 'assignment');
  // add console logging here and check for props
  if (assignment && checkForProp(assignment, key)) {
    return checkForProp(assignment, key);
  }
};

export const model = (row: any, key: string) => {
  const model = checkForProp(row, 'model');
  if (model && checkForProp(model, key)) {
    return checkForProp(model, key);
  }
};

export const alert = (row: any, key: string) => {
  const assignment = checkForProp(row, 'alert');
  if (assignment && checkForProp(assignment, key)) {
    return checkForProp(assignment, key);
  }
};

// general prop check which can allow for recursive checking, if you want/need
export const checkForProp = (object: any, prop: string) => {
  return resolvePath(object, prop);
};
